import {
  FormControl as FormControlCore,
  ListItemText as ListItemTextCore,
  MenuItem as MenuItemCore,
} from '@material-ui/core';
import * as lib from '~/dependencies';

export const MenuProps = {
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'left',
  },
  transformOrigin: {
    vertical: 'top',
    horizontal: 'left',
  },
  getContentAnchorEl: null,
};

export const FormControl = lib.styled(FormControlCore)`
  min-width: ${(props: { width: any }) =>
    props.width ? `${props.width}px !important;` : `110px !important;`}
  max-width: ${(props: { width: any }) =>
    props.width ? `${props.width}px !important;` : `110px !important;`}
  background-color: white;
  border: 1px solid #f5f5f8 !important;
  border-radius: 8px;

  .MuiInput-underline:before {
    content: unset;
  }

  .MuiSelect-select.MuiSelect-select {
    font-size: 11px !important;
    padding-left: 8px !important;
  }

  .MuiInputBase-input {
    height: 16px;
    border-radius: 8px;
    padding-left: 8px !important;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-weight: 700;
    color: grey; 
    ${(props: { hasselecteditems: number | undefined }) =>
      props?.hasselecteditems ? `background-color: #e6f0f3;` : ``}


    svg {
      width: 14px  !important;
      height: 14px  !important;
    }
  }

  .MuiOutlinedInput-input:focused {
    all: revert;
  }

  .MuiInput-underline:after {
    all: revert;
  }
`;

export const ListItemText = lib.styled(ListItemTextCore)`
  .MuiTypography-body1 {
    ${(props: { firstItem: boolean | undefined }) =>
      props?.firstItem ? `margin-left: 3px;` : `margin-left: 8px;`}

    font-size:  ${(props: { firstItem: boolean | undefined }) =>
      props.firstItem ? `14px` : `12px`}

    ${({ color }: { color?: string }) => color && `color: ${color};`}

    ${({ fontWeight }: { fontWeight?: 'normal' | 'bold' | '900' }) =>
      fontWeight && `font-weight: ${fontWeight};`}
`;

export const SVGContainer = lib.styled.div`
  div > div {
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

export const MenuItem = lib.styled(MenuItemCore)`
    min-width: 160px !important;
    max-height: 50px !important;

    ${(props: { firstItem: boolean | undefined }) =>
      props?.firstItem && `padding-top: 0px;`}

    ${(props: { background: any }) =>
      props.background &&
      `
        margin-bottom: 5px !important; 
        margin-left: 10px !important; 
        margin-right: 10px !important;
        border-radius: 10px !important;
        background-color: ${props.background} !important;`}

    .PrivateSwitchBase-root-6 {
        padding: unset;
        margin-right: 10px;
    }

    .PrivateSwitchBase-root-2 {
      padding: unset !important;
    }

    .MuiCheckbox-root {
      color: ${(props: { background: any }) =>
        props.background ? `rgb(255 255 255 / 54%);` : `rgba(0, 0, 0, 0.54);`}
    }

    .MuiCheckbox-colorSecondary.Mui-checked {
      color: #969799 !important;
    }

    .MuiSvgIcon-root {
        width: 18px;
        height: 18px;
    }

    .direction-icon {
        margin-top: 5px !important;
        padding-left: 12px !important;  

        width: 22px  !important;
        height: 22px  !important;

        max-width: 22px !important;
        max-height: 22px  !important;


        svg {
            width: 16px  !important;
            height: 16px  !important;
        }
    }
`;
